export function hasAsianText(text: any): boolean {
  if (!text || !text.toString) {
    return false;
  }

  const asianRegex =
    /[\u3040-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uAC00-\uD7AF\uF900-\uFAFF]/;
  return asianRegex.test(text.toString());
}
